import { CountriesFlagsForLanguage } from '@/components/countries';
import { Button, ListItem, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useState } from 'react';
import type { StepNavigation } from '../../light/user-settings/models';

export function SettingsLanguageSectionWooDark({
  goToMain,
}: Readonly<StepNavigation<never, never>>) {
  const { language, languages, t, changeLanguage } = useI18n();
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  function handleSelectLanguage() {
    changeLanguage(selectedLanguage);
    goToMain();
  }
  return (
    <div className="flex size-full flex-col gap-4">
      <ul className="grid gap-4">
        {languages.map((lang) => {
          const CountryFlag = CountriesFlagsForLanguage[lang] || <></>;
          return (
            <li key={lang}>
              <ListItem
                skin="woo-dark"
                data-active={lang === selectedLanguage}
                data-tid={`button-language-${lang}`}
                title={t(`Common.Language.Options.${lang}`)}
                className="hover:outline-3 hover:outline-woo-green focus-visible:outline-woo-green data-[active=true]:outline-3 data-[active=true]:outline-woo-green data-[pressing=true]:outline-woo-green"
                leadingIcon={
                  <div className="size-6 rounded-full p-1 ring-1 ring-nos-neutral-0">
                    <div
                      data-checked={lang === selectedLanguage}
                      className="size-full rounded-full data-[checked=true]:bg-nos-neutral-0"
                    ></div>
                  </div>
                }
                trailingIcon={<CountryFlag />}
                onClick={() => {
                  setSelectedLanguage(lang);
                }}
              />
            </li>
          );
        })}
      </ul>
      <div className="absolute inset-x-0 bottom-0 mt-auto p-6 shadow-top-1">
        <Button
          disabled={selectedLanguage === language}
          skin="woo-dark"
          onClick={handleSelectLanguage}
          className="w-fit"
          data-tid="button-confirm-language"
        >
          {t('Common.Language.Confirm')}
        </Button>
      </div>
    </div>
  );
}
